/** @format */

import template from './gb-edit-tools.html';
import './gb-edit-tools.scss';

export const GbEditToolsComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    controller: class GbEditToolsComponent {
        constructor($log, $ccToast, $timeout, $q, $translate) {
            'ngInject';

            this.$log = $log;

            this.$ccToast = $ccToast;
            this.$timeout = $timeout;
            this.$q = $q;

            this.rowLayout = false;
            this.hidingDragTooltip = false;
            this.activePanel = null;

            this.$saveTimeout = null;
            this.$saveTimeoutDelay = 500;

            this.selectedItem = null;

            let _this = this;

            this.panelButton = class {
                constructor(params = {}) {
                    this.text = params.text;
                    this.icon = params.icon;
                }

                isSelected() {
                    return _this.selectedItem === this;
                }

                toggle() {
                    if (_this.selectedItem === this) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                }

                select() {
                    _this.selectedItem = this;
                }

                deselect() {
                    if (_this.selectedItem === this) {
                        _this.selectedItem = null;
                    }
                }
            };

            this.templatesButton = new this.panelButton({
                text: $translate.instant('EDIT_TOOLS_TEMPLATES'),
                icon: 'description',
            });

            this.addWidgetButton = new this.panelButton({
                text: $translate.instant('EDIT_TOOLS_ADD_WIDGET'),
                icon: 'add',
            });

            this.backgroundButton = new this.panelButton({
                text: $translate.instant('EDIT_TOOLS_BACKGROUND'),
                icon: 'texture',
            });

            this.cssButton = new this.panelButton({
                text: $translate.instant('EDIT_TOOLS_CUSOM_CSS'),
                icon: 'code',
            });

            this.panelButtons = [this.templatesButton, this.addWidgetButton, this.backgroundButton, this.cssButton];
        }

        rotateTools() {
            this.rowLayout = !this.rowLayout;
        }

        onDrag() {
            this.hidingDragTooltip = true;
        }

        onDrop() {
            this.hidingDragTooltip = false;
        }

        closeCustomCssPanel() {
            this.cssButton.deselect();
        }

        closeBackgroundPanel() {
            this.backgroundButton.deselect();
        }

        formInvalid() {
            return this.editToolsForm.$invalid;
        }

        saveWidget() {
            this.$savePromise = this.$q.defer();

            if (this.$saveTimeout) {
                this.$timeout.cancel(this.$saveTimeout);
            }

            if (!this.formInvalid()) {
                this.$saveTimeout = this.$timeout(() => {
                    this.$saveWidget()
                        .then((data) => {
                            this.$savePromise.resolve(data);
                        })
                        .catch((err) => {
                            this.$savePromise.reject(err);
                        });
                }, this.$saveTimeoutDelay);
            }

            return this.$savePromise.promise;
        }

        $saveWidget() {
            this.gbPresenter.getCopiedWidget().projector = this.gbApp.getProjectorId();
            let widgetCache = this.gbPresenter.getCopiedWidget().constructor.cache;

            return this.gbPresenter
                .getCopiedWidget()
                .constructor.update(
                    {
                        auction: this.gbApp.getAuctionUrl(),
                    },
                    this.gbPresenter.getCopiedWidget()
                )
                .$promise.then((data) => {
                    this.$log.info('Saved Widget', data);
                    widgetCache.push(data);
                    return data;
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                    throw err;
                });
        }

        closeTemplatePanel() {
            this.templatesButton.deselect();
        }
    },
};
